/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ThreeInputs */

const cs_enum_three = /** @type {(inputs: Enum_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3`)
};

const en_enum_three = /** @type {(inputs: Enum_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3`)
};

/**
* | output |
* | --- |
* | "3" |
*
* @param {Enum_ThreeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_three = /** @type {((inputs?: Enum_ThreeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ThreeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_three(inputs)
	return cs_enum_three(inputs)
});